/* eslint-disable max-len */
const WindSvg1 = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" width="12" height="12"><path d="M576.00000001 512l-128.00000002 0L448 970.68799999A53.312 53.312 0 0 0 501.312 1024l21.376 0A53.312 53.312 0 0 0 576 970.68799999L576.00000001 512z" fill="#333303"></path><path d="M781.824 430.72l-220.8-358.08a53.312 53.312 0 0 0-90.432-0.576l-226.752 358.08A53.312 53.312 0 0 0 288.896 512L736.44799999 512a53.312 53.312 0 0 0 45.44000002-81.28z" fill="#333303"></path></svg>';
const WindSvg2 = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" width="16" height="16"><path d="M576.00000001 512l-128.00000002 0L448 970.68799999A53.312 53.312 0 0 0 501.312 1024l21.376 0A53.312 53.312 0 0 0 576 970.68799999L576.00000001 512z" fill="#333303"></path><path d="M781.824 430.72l-220.8-358.08a53.312 53.312 0 0 0-90.432-0.576l-226.752 358.08A53.312 53.312 0 0 0 288.896 512L736.44799999 512a53.312 53.312 0 0 0 45.44000002-81.28z" fill="#333303"></path></svg>';
const WindSvg3 = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" width="20" height="20"><path d="M576.00000001 512l-128.00000002 0L448 970.68799999A53.312 53.312 0 0 0 501.312 1024l21.376 0A53.312 53.312 0 0 0 576 970.68799999L576.00000001 512z" fill="#333303"></path><path d="M781.824 430.72l-220.8-358.08a53.312 53.312 0 0 0-90.432-0.576l-226.752 358.08A53.312 53.312 0 0 0 288.896 512L736.44799999 512a53.312 53.312 0 0 0 45.44000002-81.28z" fill="#333303"></path></svg>';
const WindSvg4 = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" width="24" height="24"><path d="M576.00000001 512l-128.00000002 0L448 970.68799999A53.312 53.312 0 0 0 501.312 1024l21.376 0A53.312 53.312 0 0 0 576 970.68799999L576.00000001 512z" fill="#333303"></path><path d="M781.824 430.72l-220.8-358.08a53.312 53.312 0 0 0-90.432-0.576l-226.752 358.08A53.312 53.312 0 0 0 288.896 512L736.44799999 512a53.312 53.312 0 0 0 45.44000002-81.28z" fill="#333303"></path></svg>';

export const WindSpeedSvg1 = `data:image/svg+xml;utf8,${encodeURIComponent(WindSvg1)}`;
export const WindSpeedSvg2 = `data:image/svg+xml;utf8,${encodeURIComponent(WindSvg2)}`;
export const WindSpeedSvg3 = `data:image/svg+xml;utf8,${encodeURIComponent(WindSvg3)}`;
export const WindSpeedSvg4 = `data:image/svg+xml;utf8,${encodeURIComponent(WindSvg4)}`;


export const Daily1 = require('@/resource/weather-image/Daily/1_Daily.png');
export const Daily2 = require('@/resource/weather-image/Daily/2_Daily.png');
export const Daily3 = require('@/resource/weather-image/Daily/3_Daily.png');
export const Daily4 = require('@/resource/weather-image/Daily/4_Daily.png');
export const Daily5 = require('@/resource/weather-image/Daily/5_Daily.png');
export const Daily6 = require('@/resource/weather-image/Daily/6_Daily.png');
export const Daily7 = require('@/resource/weather-image/Daily/7_Daily.png');
export const Daily8 = require('@/resource/weather-image/Daily/8_Daily.png');
export const Daily9 = require('@/resource/weather-image/Daily/9_Daily.png');
export const Daily10 = require('@/resource/weather-image/Daily/10_Daily.png');
export const Daily11 = require('@/resource/weather-image/Daily/11_Daily.png');
export const Daily12 = require('@/resource/weather-image/Daily/12_Daily.png');
export const Daily13 = require('@/resource/weather-image/Daily/13_Daily.png');
export const Daily14 = require('@/resource/weather-image/Daily/14_Daily.png');
export const Daily15 = require('@/resource/weather-image/Daily/15_Daily.png');
export const Daily16 = require('@/resource/weather-image/Daily/16_Daily.png');
export const Daily17 = require('@/resource/weather-image/Daily/17_Daily.png');

// console.log('ggg daily Daily1',Daily1);
// console.log('ggg daily Daily2',Daily2);
// console.log('ggg daily Daily3',Daily3);
// console.log('ggg daily Daily4',Daily4);
// console.log('ggg daily Daily5',Daily5);
// console.log('ggg daily Daily6',Daily6);
// console.log('ggg daily Daily7',Daily7);
// console.log('ggg daily Daily8',Daily8);
// console.log('ggg daily Daily9',Daily9);
// console.log('ggg daily Daily10',Daily10);
// console.log('ggg daily Daily11',Daily11);
// console.log('ggg daily Daily12',Daily12);
// console.log('ggg daily Daily13',Daily13);
// console.log('ggg daily Daily14',Daily14);
// console.log('ggg daily Daily15',Daily15);
// console.log('ggg daily Daily16',Daily16);
// console.log('ggg daily Daily17',Daily17);


export const Hourly1Day = require('@/resource/weather-image/Hourly/1_Hourly_Day.png');
export const Hourly1Night = require('@/resource/weather-image/Hourly/1_Hourly_Night.png');
export const Hourly2Day = require('@/resource/weather-image/Hourly/2_Hourly_Day.png');
export const Hourly2Night = require('@/resource/weather-image/Hourly/2_Hourly_Night.png');
export const Hourly3Day = require('@/resource/weather-image/Hourly/3_Hourly_Day.png');
export const Hourly3Night = require('@/resource/weather-image/Hourly/3_Hourly_Night.png');
export const Hourly4Day = require('@/resource/weather-image/Hourly/4_Hourly_Day.png');
export const Hourly4Night = require('@/resource/weather-image/Hourly/4_Hourly_Night.png');
export const Hourly5Day = require('@/resource/weather-image/Hourly/5_Hourly_Day.png');
export const Hourly5Night = require('@/resource/weather-image/Hourly/5_Hourly_Night.png');
export const Hourly6Day = require('@/resource/weather-image/Hourly/6_Hourly_Day.png');
export const Hourly6Night = require('@/resource/weather-image/Hourly/6_Hourly_Night.png');
export const Hourly7Day = require('@/resource/weather-image/Hourly/7_Hourly_Day.png');
export const Hourly7Night = require('@/resource/weather-image/Hourly/7_Hourly_Night.png');
export const Hourly8Day = require('@/resource/weather-image/Hourly/8_Hourly_Day.png');
export const Hourly8Night = require('@/resource/weather-image/Hourly/8_Hourly_Night.png');
export const Hourly9Day = require('@/resource/weather-image/Hourly/9_Hourly_Day.png');
export const Hourly9Night = require('@/resource/weather-image/Hourly/9_Hourly_Night.png');
export const Hourly10Day = require('@/resource/weather-image/Hourly/10_Hourly_Day.png');
export const Hourly10Night = require('@/resource/weather-image/Hourly/10_Hourly_Night.png');
export const Hourly11Day = require('@/resource/weather-image/Hourly/11_Hourly_Day.png');
export const Hourly11Night = require('@/resource/weather-image/Hourly/11_Hourly_Night.png');
export const Hourly12Day = require('@/resource/weather-image/Hourly/12_Hourly_Day.png');
export const Hourly12Night = require('@/resource/weather-image/Hourly/12_Hourly_Night.png');
export const Hourly13Day = require('@/resource/weather-image/Hourly/13_Hourly_Day.png');
export const Hourly13Night = require('@/resource/weather-image/Hourly/13_Hourly_Night.png');
export const Hourly14Day = require('@/resource/weather-image/Hourly/14_Hourly_Day.png');
export const Hourly14Night = require('@/resource/weather-image/Hourly/14_Hourly_Night.png');
export const Hourly15Day = require('@/resource/weather-image/Hourly/15_Hourly_Day.png');
export const Hourly15Night = require('@/resource/weather-image/Hourly/15_Hourly_Night.png');
export const Hourly16Day = require('@/resource/weather-image/Hourly/16_Hourly_Day.png');
export const Hourly16Night = require('@/resource/weather-image/Hourly/16_Hourly_Night.png');
export const Hourly17Day = require('@/resource/weather-image/Hourly/17_Hourly_Day.png');
export const Hourly17Night = require('@/resource/weather-image/Hourly/17_Hourly_Night.png');
export const Hourly18Day = require('@/resource/weather-image/Hourly/18_Hourly_Day.png');
export const Hourly18Night = require('@/resource/weather-image/Hourly/18_Hourly_Night.png');
export const Hourly19Day = require('@/resource/weather-image/Hourly/19_Hourly_Day.png');
export const Hourly19Night = require('@/resource/weather-image/Hourly/19_Hourly_Night.png');
export const Hourly20Day = require('@/resource/weather-image/Hourly/20_Hourly_Day.png');
export const Hourly20Night = require('@/resource/weather-image/Hourly/20_Hourly_Night.png');
export const Hourly21Day = require('@/resource/weather-image/Hourly/21_Hourly_Day.png');
export const Hourly21Night = require('@/resource/weather-image/Hourly/21_Hourly_Night.png');
export const Hourly22Day = require('@/resource/weather-image/Hourly/22_Hourly_Day.png');
export const Hourly22Night = require('@/resource/weather-image/Hourly/22_Hourly_Night.png');
export const Hourly23Day = require('@/resource/weather-image/Hourly/23_Hourly_Day.png');
export const Hourly23Night = require('@/resource/weather-image/Hourly/23_Hourly_Night.png');
export const Hourly24Day = require('@/resource/weather-image/Hourly/24_Hourly_Day.png');
export const Hourly24Night = require('@/resource/weather-image/Hourly/24_Hourly_Night.png');
export const Hourly25Day = require('@/resource/weather-image/Hourly/25_Hourly_Day.png');
export const Hourly25Night = require('@/resource/weather-image/Hourly/25_Hourly_Night.png');
export const Hourly26Day = require('@/resource/weather-image/Hourly/26_Hourly_Day.png');
export const Hourly26Night = require('@/resource/weather-image/Hourly/26_Hourly_Night.png');
export const Hourly27Day = require('@/resource/weather-image/Hourly/27_Hourly_Day.png');
export const Hourly27Night = require('@/resource/weather-image/Hourly/27_Hourly_Night.png');
export const Hourly28Day = require('@/resource/weather-image/Hourly/28_Hourly_Day.png');
export const Hourly28Night = require('@/resource/weather-image/Hourly/28_Hourly_Night.png');
export const Hourly29Day = require('@/resource/weather-image/Hourly/29_Hourly_Day.png');
export const Hourly29Night = require('@/resource/weather-image/Hourly/29_Hourly_Night.png');
export const Hourly30Day = require('@/resource/weather-image/Hourly/30_Hourly_Day.png');
export const Hourly30Night = require('@/resource/weather-image/Hourly/30_Hourly_Night.png');
export const Hourly31Day = require('@/resource/weather-image/Hourly/31_Hourly_Day.png');
export const Hourly31Night = require('@/resource/weather-image/Hourly/31_Hourly_Night.png');
export const Hourly32Day = require('@/resource/weather-image/Hourly/32_Hourly_Day.png');
export const Hourly32Night = require('@/resource/weather-image/Hourly/32_Hourly_Night.png');
export const Hourly33Day = require('@/resource/weather-image/Hourly/33_Hourly_Day.png');
export const Hourly33Night = require('@/resource/weather-image/Hourly/33_Hourly_Night.png');
export const Hourly34Day = require('@/resource/weather-image/Hourly/34_Hourly_Day.png');
export const Hourly34Night = require('@/resource/weather-image/Hourly/34_Hourly_Night.png');
export const Hourly35Day = require('@/resource/weather-image/Hourly/35_Hourly_Day.png');
export const Hourly35Night = require('@/resource/weather-image/Hourly/35_Hourly_Night.png');
// console.log('ggg hourly Hourly1Day', Hourly1Day);
// console.log('ggg hourly Hourly1Night', Hourly1Night);
// console.log('ggg hourly Hourly2Day', Hourly2Day);
// console.log('ggg hourly Hourly2Night', Hourly2Night);
// console.log('ggg hourly Hourly3Day', Hourly3Day);
// console.log('ggg hourly Hourly3Night', Hourly3Night);
// console.log('ggg hourly Hourly4Day', Hourly4Day);
// console.log('ggg hourly Hourly4Night', Hourly4Night);
// console.log('ggg hourly Hourly5Day', Hourly5Day);
// console.log('ggg hourly Hourly5Night', Hourly5Night);
// console.log('ggg hourly Hourly6Day', Hourly6Day);
// console.log('ggg hourly Hourly6Night', Hourly6Night);
// console.log('ggg hourly Hourly7Day', Hourly7Day);
// console.log('ggg hourly Hourly7Night', Hourly7Night);
// console.log('ggg hourly Hourly8Day', Hourly8Day);
// console.log('ggg hourly Hourly8Night', Hourly8Night);
// console.log('ggg hourly Hourly9Day', Hourly9Day);
// console.log('ggg hourly Hourly9Night', Hourly9Night);
// console.log('ggg hourly Hourly10Day', Hourly10Day);
// console.log('ggg hourly Hourly10Night', Hourly10Night);
// console.log('ggg hourly Hourly11Day', Hourly11Day);
// console.log('ggg hourly Hourly11Night', Hourly11Night);
// console.log('ggg hourly Hourly12Day', Hourly12Day);
// console.log('ggg hourly Hourly12Night', Hourly12Night);
// console.log('ggg hourly Hourly13Day', Hourly13Day);
// console.log('ggg hourly Hourly13Night', Hourly13Night);
// console.log('ggg hourly Hourly14Day', Hourly14Day);
// console.log('ggg hourly Hourly14Night', Hourly14Night);
// console.log('ggg hourly Hourly15Day', Hourly15Day);
// console.log('ggg hourly Hourly15Night', Hourly15Night);
// console.log('ggg hourly Hourly16Day', Hourly16Day);
// console.log('ggg hourly Hourly16Night', Hourly16Night);
// console.log('ggg hourly Hourly17Day', Hourly17Day);
// console.log('ggg hourly Hourly17Night', Hourly17Night);
// console.log('ggg hourly Hourly18Day', Hourly18Day);
// console.log('ggg hourly Hourly18Night', Hourly18Night);
// console.log('ggg hourly Hourly19Day', Hourly19Day);
// console.log('ggg hourly Hourly19Night', Hourly19Night);
// console.log('ggg hourly Hourly20Day', Hourly20Day);
// console.log('ggg hourly Hourly20Night', Hourly20Night);
// console.log('ggg hourly Hourly21Day', Hourly21Day);
// console.log('ggg hourly Hourly21Night', Hourly21Night);
// console.log('ggg hourly Hourly22Day', Hourly22Day);
// console.log('ggg hourly Hourly22Night', Hourly22Night);
// console.log('ggg hourly Hourly23Day', Hourly23Day);
// console.log('ggg hourly Hourly23Night', Hourly23Night);
// console.log('ggg hourly Hourly24Day', Hourly24Day);
// console.log('ggg hourly Hourly24Night', Hourly24Night);
// console.log('ggg hourly Hourly25Day', Hourly25Day);
// console.log('ggg hourly Hourly25Night', Hourly25Night);
// console.log('ggg hourly Hourly26Day', Hourly26Day);
// console.log('ggg hourly Hourly26Night', Hourly26Night);
// console.log('ggg hourly Hourly27Day', Hourly27Day);
// console.log('ggg hourly Hourly27Night', Hourly27Night);
// console.log('ggg hourly Hourly28Day', Hourly28Day);
// console.log('ggg hourly Hourly28Night', Hourly28Night);
// console.log('ggg hourly Hourly29Day', Hourly29Day);
// console.log('ggg hourly Hourly29Night', Hourly29Night);
// console.log('ggg hourly Hourly30Day', Hourly30Day);
// console.log('ggg hourly Hourly30Night', Hourly30Night);
// console.log('ggg hourly Hourly31Day', Hourly31Day);
// console.log('ggg hourly Hourly31Night', Hourly31Night);
// console.log('ggg hourly Hourly32Day', Hourly32Day);
// console.log('ggg hourly Hourly32Night', Hourly32Night);
// console.log('ggg hourly Hourly33Day', Hourly33Day);
// console.log('ggg hourly Hourly33Night', Hourly33Night);
// console.log('ggg hourly Hourly34Day', Hourly34Day);
// console.log('ggg hourly Hourly34Night', Hourly34Night);
// console.log('ggg hourly Hourly35Day', Hourly35Day);
// console.log('ggg hourly Hourly35Night', Hourly35Night);

export const getWeatherImage = ( isDay: boolean,weatherCode: string, weatherIndex?:number) => {
    let tmpWeatherImage = null;
    if(isDay){
        // for Daily
        switch(weatherCode){
            case '1':
                tmpWeatherImage = Daily1;
                break;
            case '2':
                tmpWeatherImage = Daily2;
                break;
            case '3':
                tmpWeatherImage = Daily3;
                break;
            case '4':
                tmpWeatherImage = Daily4;
                break;
            case '5':
                tmpWeatherImage = Daily5;
                break;
            case '6':
                tmpWeatherImage = Daily6;
                break;
            case '7':
                tmpWeatherImage = Daily7;
                break;
            case '8':
                tmpWeatherImage = Daily8;
                break;
            case '9':
                tmpWeatherImage = Daily9;
                break;
            case '10':
                tmpWeatherImage = Daily10;
                break;
            case '11':
                tmpWeatherImage = Daily11;
                break;
            case '12':
                tmpWeatherImage = Daily12;
                break;
            case '13':
                tmpWeatherImage = Daily13;
                break;
            case '14':
                tmpWeatherImage = Daily14;
                break;
            case '15':
                tmpWeatherImage = Daily15;
                break;
            case '16':
                tmpWeatherImage = Daily16;
                break;
            case '17':
                tmpWeatherImage = Daily17;
                break;
            default:
                tmpWeatherImage = null;
                break;
        }
    }
    else {
        // for Hourly and 8-Hourly
        switch(weatherCode){
            case '1':
                tmpWeatherImage = (weatherIndex === 1 ? Hourly1Day : Hourly1Night);
                break;
            case '2':
                tmpWeatherImage = (weatherIndex === 1 ? Hourly2Day : Hourly2Night);
                break;
            case '3':
                tmpWeatherImage = (weatherIndex === 1 ? Hourly3Day : Hourly3Night);
                break;
            case '4':
                tmpWeatherImage = (weatherIndex === 1 ? Hourly4Day : Hourly4Night);
                break;
            case '5':
                tmpWeatherImage = (weatherIndex === 1 ? Hourly5Day : Hourly5Night);
                break;
            case '6':
                tmpWeatherImage = (weatherIndex === 1 ? Hourly6Day : Hourly6Night);
                break;
            case '7':
                tmpWeatherImage = (weatherIndex === 1 ? Hourly7Day : Hourly7Night);
                break;
            case '8':
                tmpWeatherImage = (weatherIndex === 1 ? Hourly8Day : Hourly8Night);
                break;
            case '9':
                tmpWeatherImage = (weatherIndex === 1 ? Hourly9Day : Hourly9Night);
                break;
            case '10':
                tmpWeatherImage = (weatherIndex === 1 ? Hourly10Day : Hourly10Night);
                break;
            case '11':
                tmpWeatherImage = (weatherIndex === 1 ? Hourly11Day : Hourly11Night);
                break;
            case '12':
                tmpWeatherImage = (weatherIndex === 1 ? Hourly12Day : Hourly12Night);
                break;
            case '13':
                tmpWeatherImage = (weatherIndex === 1 ? Hourly13Day : Hourly13Night);
                break;
            case '14':
                tmpWeatherImage = (weatherIndex === 1 ? Hourly14Day : Hourly14Night);
                break;
            case '15':
                tmpWeatherImage = (weatherIndex === 1 ? Hourly15Day : Hourly15Night);
                break;
            case '16':
                tmpWeatherImage = (weatherIndex === 1 ? Hourly16Day : Hourly16Night);
                break;
            case '17':
                tmpWeatherImage = (weatherIndex === 1 ? Hourly17Day : Hourly17Night);
                break;
            case '18':
                tmpWeatherImage = (weatherIndex === 1 ? Hourly18Day : Hourly18Night);
                break;
            case '19':
                tmpWeatherImage = (weatherIndex === 1 ? Hourly19Day : Hourly19Night);
                break;
            case '20':
                tmpWeatherImage = (weatherIndex === 1 ? Hourly20Day : Hourly20Night);
                break;
            case '21':
                tmpWeatherImage = (weatherIndex === 1 ? Hourly21Day : Hourly21Night);
                break;
            case '22':
                tmpWeatherImage = (weatherIndex === 1 ? Hourly22Day : Hourly22Night);
                break;
            case '23':
                tmpWeatherImage = (weatherIndex === 1 ? Hourly23Day : Hourly23Night);
                break;
            case '24':
                tmpWeatherImage = (weatherIndex === 1 ? Hourly24Day : Hourly24Night);
                break;
            case '25':
                tmpWeatherImage = (weatherIndex === 1 ? Hourly25Day : Hourly25Night);
                break;
            case '26':
                tmpWeatherImage = (weatherIndex === 1 ? Hourly26Day : Hourly26Night);
                break;
            case '27':
                tmpWeatherImage = (weatherIndex === 1 ? Hourly27Day : Hourly27Night);
                break;
            case '28':
                tmpWeatherImage = (weatherIndex === 1 ? Hourly28Day : Hourly28Night);
                break;
            case '29':
                tmpWeatherImage = (weatherIndex === 1 ? Hourly29Day : Hourly29Night);
                break;
            case '30':
                tmpWeatherImage = (weatherIndex === 1 ? Hourly30Day : Hourly30Night);
                break;
            case '31':
                tmpWeatherImage = (weatherIndex === 1 ? Hourly31Day : Hourly31Night);
                break;
            case '32':
                tmpWeatherImage = (weatherIndex === 1 ? Hourly32Day : Hourly32Night);
                break;
            case '33':
                tmpWeatherImage = (weatherIndex === 1 ? Hourly33Day : Hourly33Night);
                break;
            case '34':
                tmpWeatherImage = (weatherIndex === 1 ? Hourly34Day : Hourly34Night);
                break;
            case '35':
                tmpWeatherImage = (weatherIndex === 1 ? Hourly35Day : Hourly35Night);
                break;
            default:
                tmpWeatherImage = null;
                break;
        }
    }
    return tmpWeatherImage;
};


export const testOptions = {
    'grid': {
        'containLabel': false,
        'left': '4%',
        'right': 150,
        'bottom': '16%',
        'top': 20,
        'height': 400
    },
    'tooltip': {
        'trigger': 'axis',
        'axisPointer': {
            'type': 'cross'
        }
    },
    'legend': {
        'data': [
            'Cloud Cover',
            'Air Pressure',
            'Wind Gust'
        ],
        'top': 440
    },
    'xAxis': {
        'type': 'category',
        'data': [
            '22/01/2024',
            '29/01/2024',
            '05/02/2024',
            '12/02/2024',
            '19/02/2024',
            '26/02/2024',
            '04/03/2024',
            '11/03/2024',
            '18/03/2024',
            '25/03/2024',
            '01/04/2024',
            '08/04/2024',
            '15/04/2024',
            '22/04/2024',
            '29/04/2024',
            '06/05/2024',
            '13/05/2024',
            '20/05/2024',
            '27/05/2024',
            '03/06/2024',
            '10/06/2024',
            '17/06/2024',
            '24/06/2024',
            '01/07/2024',
            '08/07/2024',
            '15/07/2024',
            '22/07/2024',
            '29/07/2024',
            '05/08/2024',
            '12/08/2024',
            '19/08/2024',
            '26/08/2024',
            '02/09/2024',
            '09/09/2024',
            '16/09/2024',
            '23/09/2024',
            '30/09/2024',
            '07/10/2024',
            '14/10/2024',
            '21/10/2024',
            '28/10/2024',
            '04/11/2024',
            '11/11/2024',
            '18/11/2024',
            '25/11/2024',
            '02/12/2024',
            '09/12/2024',
            '16/12/2024',
            '23/12/2024',
            '30/12/2024',
            '06/01/2025',
            '13/01/2025'
        ],
        'axisTick': {
            'show': false
        },
        'axisLabel': {
            inteval: null,
        },
        'splitline': null
    },
    'yAxis': [
        {
            'type': 'value',
            'name': 'Percentage (%)',
            'position': 'right',
            'offset': 0,
            'nameGap': 35,
            'nameRotate': 90,
            'nameLocation': 'middle',
            'nameTextStyle': {
                'color': '#3B89C7',
                'fontFamily': 'Noto-Sans-Regular, sans-serif',
                'fontSize': 11
            },
            'axisTick': {
                'show': true
            },
            'axisLine': {
                'show': true,
                'lineStyle': {
                    'color': '#3B89C7'
                }
            }
        },
        {
            'type': 'value',
            'name': 'Air Pressure (hPa)',
            'position': 'right',
            'offset': 50,
            'nameGap': 35,
            'nameRotate': 90,
            'nameLocation': 'middle',
            'nameTextStyle': {
                'color': '#4B0082',
                'fontFamily': 'Noto-Sans-Regular, sans-serif',
                'fontSize': 11
            },
            'axisTick': {
                'show': true
            },
            'axisLine': {
                'show': true,
                'lineStyle': {
                    'color': '#4B0082'
                }
            }
        },
        {
            'type': 'value',
            'name': 'Speed (km/h)',
            'position': 'right',
            'offset': 100,
            'nameGap': 35,
            'nameRotate': 90,
            'nameLocation': 'middle',
            'nameTextStyle': {
                'color': '#7B68EE',
                'fontFamily': 'Noto-Sans-Regular, sans-serif',
                'fontSize': 11
            },
            'axisTick': {
                'show': true
            },
            'axisLine': {
                'show': true,
                'lineStyle': {
                    'color': '#7B68EE'
                }
            }
        }
    ],
    'graphic': [],
    'series': [
        {
            'name': 'Cloud Cover',
            'type': 'line',
            'label': {
                'show': false,
                'position': 'top'
            },
            'lineStyle': {
                'type': 'solid'
            },
            'color': '#3B89C7',
            'yAxisIndex': 0,
            'data': [
                '80.7',
                '83.5',
                '57.8',
                '39.2',
                '86.5',
                '81.5',
                '85.1',
                '86.6',
                '72',
                '61.2',
                '94.4',
                '69.5',
                '83.9',
                '67.7',
                '84.1',
                '74.9',
                '58.8',
                '45.6',
                '88.7',
                '89.9',
                '67.7',
                '83.2',
                '73.2',
                '78.2',
                '89.7',
                '83.4',
                '82.2',
                '63.1',
                '59.6',
                '48.5',
                '37.3',
                '51.7',
                '48.3',
                '70.2',
                '71.5',
                '65.3',
                '91.8',
                '90.7',
                '81.4',
                '86.9',
                '91.3',
                '92.9',
                '97.1',
                '85.9',
                '71.2',
                '87.9',
                '66.8',
                '59.2',
                '74.3',
                '41.8',
                '64',
                '74.8'
            ]
        },
        {
            'name': 'Air Pressure',
            'type': 'line',
            'label': {
                'show': false,
                'position': 'top'
            },
            'lineStyle': {
                'type': 'solid'
            },
            'color': '#4B0082',
            'yAxisIndex': 1,
            'data': [
                '790.4',
                '783.7',
                '788.6',
                '784.7',
                '785.4',
                '785.9',
                '787.4',
                '789',
                '787.2',
                '788.7',
                '786.7',
                '790.1',
                '787.4',
                '786.8',
                '787.2',
                '793',
                '792.7',
                '791.5',
                '790.1',
                '790.9',
                '790.1',
                '788.3',
                '789.5',
                '787.2',
                '788',
                '788.5',
                '788.6',
                '790.1',
                '790.5',
                '793.6',
                '792.9',
                '793.2',
                '793.4',
                '792.6',
                '795.5',
                '792.8',
                '795.5',
                '794',
                '792.6',
                '794.7',
                '793.8',
                '794.7',
                '789.9',
                '791.6',
                '790.3',
                '789',
                '790.3',
                '788',
                '790.4',
                '788',
                '791',
                '824.6'
            ]
        },
        {
            'name': 'Wind Gust',
            'type': 'line',
            'label': {
                'show': false,
                'position': 'top'
            },
            'lineStyle': {
                'type': 'solid'
            },
            'color': '#7B68EE',
            'yAxisIndex': 2,
            'data': [
                '23.4',
                '23.4',
                '24.8',
                '34.2',
                '29.9',
                '27',
                '29.9',
                '28.4',
                '35.3',
                '30.2',
                '32',
                '33.5',
                '31.3',
                '32.8',
                '33.8',
                '32.8',
                '32.4',
                '28.4',
                '28.8',
                '31.3',
                '30.6',
                '28.1',
                '30.2',
                '30.6',
                '28.1',
                '34.9',
                '26.6',
                '29.2',
                '46.1',
                '26.6',
                '26.6',
                '25.9',
                '31.7',
                '37.4',
                '34.2',
                '46.8',
                '25.9',
                '27',
                '29.5',
                '31',
                '28.1',
                '29.5',
                '28.8',
                '26.6',
                '25.2',
                '25.6',
                '25.9',
                '21.2',
                '23',
                '31.7',
                '22.3',
                '67.3'
            ]
        }
    ]
};